export enum BANNER_CATEGORY {
  MAIN = 1,
  LMS = 2,
}
